import {FormControl, Grid, makeStyles, MenuItem, Select} from "@material-ui/core";
import React from "react";
import customAxios from "../../../../API/customAxios";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import {adminDialogStyle} from "../../../../UIComponent/CommonStyle";
import MultiUpdateReviewDialog from "./MultiUpdateReviewDialog";

const useStyles = makeStyles((theme) => ({
    ...adminDialogStyle(theme),
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        alignItems: 'unset',
    },
    changeApproverContainer: {
        fontSize: '16px',
        display: 'flex',
        alignItems: 'center'
    },
    approverButton: {
        backgroundColor: '#2C3E50',
        '&:hover': {
            backgroundColor: '#080C0F',
        },
    }
}));

export default function MultiSelctUpdate({selectedEmployeeIDs, selectedEmployeeNames, updateTable}) {
    const classes = useStyles();
    const [values, setValues] = React.useState({
        firstApproverId: '',
        secondApproverId: ''
    });
    const [employeeList, setEmployeeList] = React.useState([]);
    const [showDialog, setShowDialog] = React.useState(false);
    const [updateAction, setUpdateAction] = React.useState('');
    const [newApproverID, setNewApproverID] = React.useState(0);
    const [selectedApproverName, setSelectedApproverName] = React.useState('');

    React.useEffect(() => {
        customAxios.get(`/get_employee?filter[active]=1&select[]=position&select[]=employee_name&select[]=id`)
            .then(res => {
                setEmployeeList(res.data);
                setValues({
                    firstApproverId: res.data[0].id,
                    secondApproverId: res.data[1].id,
                });
            })
    }, [])

    const handleApproverChange = (event) => {
        const name = event.target.name;
        setValues({
            ...values,
            [name]: event.target.value,
        });
    };

    const confirmFirstApprover = () => {
        if (selectedEmployeeIDs.length > 0) {
            setUpdateAction('ChangeFirstApprover');
            setNewApproverID(values.firstApproverId);
            getSelectedEmployeeNames(values.firstApproverId);
            setShowDialog(true);
        }
    }

    const confirmSecondApprover = () => {
        if (selectedEmployeeIDs.length > 0) {
            if (values.secondApproverId === 'None') {
                setUpdateAction('RemoveSecondApprover');
            } else {
                setUpdateAction('ChangeSecondApprover');
                setNewApproverID(values.secondApproverId);
            }
            getSelectedEmployeeNames(values.secondApproverId);
            setShowDialog(true);
        }
    }

    const getSelectedEmployeeNames = (approverID) => {
        let newApproverData = employeeList.find(obj => {
            return obj.id === approverID
        })
        setSelectedApproverName(newApproverData ? newApproverData['employee_name'] : '');
    }

    const handleDialogClose = () => {
        setShowDialog(false);
    };

    const updateApproverTable = () => {
        updateTable(selectedApproverName, updateAction);
    }

    return (
        <Grid item xs={12}>
            {employeeList.length > 0 ?
                <div>
                    <div className={classes.changeApproverContainer}>
                        <span>Change selected 1st approver to</span>
                        <FormControl className={classes.formControl}>
                            <Select
                                id="first_approver_id"
                                value={values.firstApproverId}
                                onChange={handleApproverChange}
                                inputProps={{
                                    name: 'firstApproverId',
                                    id: 'first-approver-native-disabled',
                                }}
                            >
                                {employeeList.map(({id, employee_name, position}, index) => {
                                    return <MenuItem key={index} value={id}>
                                        {employee_name + ' (' + position + ')'}</MenuItem>;
                                })}
                            </Select>
                        </FormControl>
                        <Button variant="contained" color="primary" size="small"
                                className={classes.approverButton}
                                onClick={confirmFirstApprover}>Confirm</Button>
                    </div>
                    <div className={classes.changeApproverContainer}>
                        <span>Change selected 2nd approver to</span>
                        <FormControl className={classes.formControl}>
                            <Select
                                id="second_approver_id"
                                value={values.secondApproverId}
                                onChange={handleApproverChange}
                                inputProps={{
                                    name: 'secondApproverId',
                                    id: 'second-approver-native-disabled',
                                }}
                                label="Second Approver"
                            >
                                <MenuItem aria-label="None" value="None">None</MenuItem>
                                {employeeList.map(({id, employee_name, position}, index) => {
                                    return <MenuItem key={index} value={id}>
                                        {employee_name + ' (' + position + ')'}</MenuItem>;
                                })}
                            </Select>
                        </FormControl>
                        <Button variant="contained" color="primary" size="small"
                                className={classes.approverButton}
                                onClick={confirmSecondApprover}>Confirm</Button>
                    </div>
                </div>
                :
                <div className={classes.circularProgress}>
                    <CircularProgress/>
                </div>
            }
            {showDialog && <MultiUpdateReviewDialog
                open={showDialog} onClose={handleDialogClose}
                updateAction={updateAction}
                selectedEmployeeNames={selectedEmployeeNames}
                approverID={newApproverID} selectedEmployeeIDs={selectedEmployeeIDs}
                selectedApproverName={selectedApproverName}
                updateApproverTable={updateApproverTable}
            />}
        </Grid>
    )
}
